// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"df77a744d72efc1a","5871":"0b8133f848302575"}[chunkId] + ".css";
};